import { Upload, X } from "lucide-react";
import { compressImage } from "@/lib/api";

export const ImageInput = ({ label, value, onChange, testid, max = 900 }) => {
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (f) onChange(await compressImage(f, max));
  };
  return (
    <div>
      <span className="text-xs text-[#A89F91] font-medium">{label}</span>
      <div className="mt-1.5 flex gap-3 items-center">
        <div className="w-16 h-16 rounded-xl bg-[#120E0E] border border-[#2E2323] overflow-hidden shrink-0 relative">
          {value && <img src={value} alt="" className="w-full h-full object-cover" />}
          {value && <button type="button" onClick={() => onChange("")} className="absolute top-0.5 right-0.5 bg-black/70 rounded-full p-0.5" data-testid={`${testid}-clear`}><X className="w-3 h-3" /></button>}
        </div>
        <div className="flex-1 space-y-2 min-w-0">
          <input value={value?.startsWith("data:") ? "(imagen subida)" : value || ""} onChange={(e) => onChange(e.target.value)} placeholder="Pegá una URL de imagen"
            className="field-dark w-full rounded-lg px-3 py-2 text-xs focus:outline-none focus:border-amber-500" data-testid={`${testid}-url`} />
          <label className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-amber-500/10 text-amber-400 border border-amber-500/30 cursor-pointer hover:bg-amber-500/20">
            <Upload className="w-3.5 h-3.5" /> Subir desde el dispositivo
            <input type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`${testid}-file`} />
          </label>
        </div>
      </div>
    </div>
  );
};
